export enum CreatorThumbnailSize {
	VERY_VERY_SMALL = '50/50',
	VERY_SMALL = '75/75',
	SMALL = '140/140',
	MEDIUM = '250/250',
	LARGE = '420/420',
	VERY_LARGE = '512/512',
	VERY_VERY_LARGE = '700/700',
}
